// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1Kqif","header":"Messages_header__t1Qnb"};